import React from 'react';
import Navbar from '../components/Navbar';
import './OurStory.css';

const OurStory = () => {
    return (
        <div>
            <Navbar />
            <section className="our-story section">
                <div className="story-container">
                    <hr className="divider" /> {/* Top Divider */}
                    <h1 className="section-title">
                        Our Story
                    </h1>
                    <div className="story-content">
                        <p>
                            Once upon a time, in the vast digital sea of modern romance, Seneca found herself scrolling through profiles on Hinge. 
                            She wasn't looking for just anyone—she was looking for something real and meaningful. That's when Tim caught her eye: 
                            handsome, adventurous, and a traveler—three things that immediately grabbed her attention. Without hesitation, Seneca 
                            made the first move, sending a message that would unknowingly set the course for their forever.
                        </p>
                        <p>
                            Tim, with his quick wit and natural charm, had Seneca laughing in no time. Their messages bounced back and forth like 
                            a well-rehearsed script from a romantic comedy. Before long, he asked her on a date, but there was a catch—Tim lived 
                            in Los Angeles, and Seneca resided in Orange County. If you know anything about Southern California, you know that the 
                            distance between these two places is measured less in miles and more in unpredictable traffic.
                        </p>
                        <p>
                            Determined to meet but unwilling to submit to the freeway's tyranny, they agreed to go on a date halfway in a town 
                            neither of them knew: Downey. In an amusing twist of fate, Tim chose Friday night for their first date, breaking Seneca's 
                            cardinal rule. After a long week of seeing clients in her private practice, Friday evenings were sacred for unwinding. She 
                            agreed, assuming she would cancel as the day went on. Little did she know, Tim was also considering backing out, continuously 
                            pushing the meeting time later, blaming traffic (a valid excuse, albeit a convenient one).
                        </p>
                        <p>
                            Despite the hesitation—and despite the odds—they both showed up.
                        </p>
                        <p>
                            In a little bar, in a town they knew nothing about, fate took the reins. Conversation flowed effortlessly, laughter echoed in 
                            the air, and the connection was undeniable. From that night on, they were inseparable, bonding over their shared love for 
                            adventure, food, and discovering new places. With each passing day, their love deepened, feeling easy and natural—like coming 
                            home after a long journey. In a world that had never quite granted such grace to them, they found safety in each other.
                        </p>
                        <p>
                            It didn't take long for Seneca and Tim to realize they were meant to be. Moving in together felt less like a leap and more like 
                            a step in the right direction. They dated for over a year and a half before Tim decided to make their love story a forever kind 
                            of thing.
                        </p>
                        <p>
                            Now, Seneca—ever the inquisitive mind—had a habit of playing detective when it came to special occasions. Every time Tim told her 
                            to get ready for dinner, she would launch a full-fledged investigation to determine whether she should prepare for an engagement. 
                            Tim, steadfast and unshaken, never cracked. What she didn't know was that he had been holding onto the ring for months, having 
                            picked it out with his mother on the east coast during one of his visits.
                        </p>
                        <p>
                            Grand gestures were never Tim's style, but small, intimate, and deeply meaningful moments were where he excelled. So, in the early 
                            morning on a random day, when the world was still quiet, he chose his moment. There were no grand speeches, no elaborate setups—just 
                            the two of them, nestled in bed, a hot cup of coffee in Seneca's hands, and their baby boy Harley curled up beside them. No makeup, 
                            no expectations—just raw, unfiltered love.
                        </p>
                        <p>
                            It was not the proposal Seneca had anticipated, but it was the one her heart had always needed. With a simple, tearful 'yes', their 
                            love story turned into forever.
                        </p>
                        <p>
                            From a random bar in Downey to a lifetime of adventure, Tim and Seneca's love is proof that sometimes, the best things happen when you 
                            least expect them, yet exactly when they're meant to. 
                        </p>
                    </div>
                    <hr className="divider" /> {/* Bottom Divider */}
                </div>
            </section>
        </div>
    );
};

export default OurStory;
